function Alert(logId)
{
	var self = this;

	this.name = this.name || '';

	this.logId = logId;
	this.logId = (!isNaN(this.logId) && this.logId !== null && parseInt(this.logId) >= 0) ? this.logId : -1;

	this.id = (!isNaN(this.id) && this.id !== null && parseInt(this.id) >= 0) ? this.id : -1;
	this.subject = this.subject || '';
	this.missingDataSubject = this.missingDataSubject || '';
	this.suppressed = (typeof this.suppressed === 'boolean') ? this.suppressed : true;

	//Type Castings
	this.parameters = (Array.isArray(this.parameters)) ? this.parameters : [];
	this.parameters.forEach(function(param) { Alerts.createParameter(self.alertId, param) });

	this.hadTriggersLoad = false;
	this.triggers = [];
	
	this.template = (this.template && this.template.hasOwnProperty('id'))
		? this.template.id
		: (!isNaN(parseInt(this.template)))
			? parseInt(this.template)
			: null;
	
	/**
	 *
	 * @type {{
	 *     number: AlertNotifyUser[]
	 * }}
	 */
	this.alertNotifyUsers = {};

	// Message IDs
	this.activeId = -1;
	this.clearId = -1;
	this.missingId = -1;

	this.activeMessage = '';
	this.clearMessage = '';
	this.missingDataMessage = '';
	this.notMissingDataMessage = '';

	if (Array.isArray(this.statusMessages))
	{
		this.statusMessages.forEach(function(statusMessage)
		{
			if (!(statusMessage.status && statusMessage.status.id)) return;
			switch (statusMessage.status.id)
			{
				case 1:
					self.activeId = statusMessage.id;
					self.activeMessage = statusMessage.message;
					self.subject = statusMessage.subject;
					break;
				case 2:
					self.clearId = statusMessage.id;
					self.clearMessage = statusMessage.message;
					self.subject = statusMessage.subject;
					break;
				case 3:
					self.missingId = statusMessage.id;
					self.missingDataMessage = statusMessage.message;
					self.missingDataSubject = statusMessage.subject;
					break;
				case 4:
					self.notMissingDataMessage = statusMessage.message;
					break;
			}
		})
	}

	else this.statusMessages = [];
	
	
	/**
	 * Sets the name of the alert
	 * @param {String} newName
	 * @returns {Alert}
	 */
	this.setName = function(newName)
	{
		if (typeof newName !== 'string' && newName && typeof newName.toString === 'function')
		{
			newName = newName.toString();
		}
		if (typeof newName === 'string')
			this.name = newName;
		
		return this;
	};
	
	this.setTemplate = function(template)
	{
		var id;
		if (template && template.hasOwnProperty('id'))
			id = template.id;
		else if (!isNaN(parseInt(template)))
			id = template;
		this.template = (!isNaN(parseInt(id))) ? parseInt(id) : null;
		return this;
	};

	/**
	 * Sets the ID of this alert and the alert ID of contained children
	 * @param {number} newId
	 */
	this.setId = function(newId)
	{
		var updateIdFunc = function(value) { if (value.hasOwnProperty('alert')) value.alert = newId; };

		this.parameters.forEach(updateIdFunc);
		this.notifyUsers.forEach(updateIdFunc);
		this.missingDataChecks.forEach(updateIdFunc);
		this.triggers.forEach(updateIdFunc);

		this.id = newId;
	};
	
	this.setNewNotesOnly = function(newNotesOnly)
	{
		this.newNotesOnly = !!newNotesOnly;
	}

	/**
	 * Sets or adds a state to the notify users of this alert
	 * @param logUser - Log User for the AlertNotifyUser
	 * @param {string=} alertType - AlertNotifyUser.type
	 * @param {string=} alertState - AlertNotifyUser.state
	 *
	 * @return {AlertNotifyUser}
	 */
	this.setNotifyUserState = function(logUser, alertType, alertState)
	{
		if (!this.alertNotifyUsers[logUser.id])
			this.alertNotifyUsers[logUser.id] = Alerts.createNotifyUser(logUser);

		if (!AlertNotifyUser.type.isValidType(alertType) || !AlertNotifyUser.state.isValidState(alertState))
			return this.alertNotifyUsers[logUser.id];

		var alertUser = this.alertNotifyUsers[logUser.id];
		if (alertType === AlertNotifyUser.type.missingData)
			return alertUser;
		else
			alertUser[alertType].state = alertState;

		if (alertType === AlertNotifyUser.type.active && !alertUser.getStateValid(AlertNotifyUser.type.clear, true))
			alertUser.clear.state = AlertNotifyUser.state.never;

		else if (alertType === AlertNotifyUser.type.clear && !alertUser.getStateValid(AlertNotifyUser.type.active, true))
			alertUser.active.state = AlertNotifyUser.state.never;

		return alertUser;
	};

	/**
	 * Checks if AlertNotifyUser exists and checks for AlertStatus
	 * @param {number} logUserId
	 * @param {string=} type - AlertNotifyUser type
	 * @param {AlertMissingDataCheck=} missingDataCheck - Missing Data Check to verify for
	 */
	this.hasNotifyUser = function(logUserId, type, missingDataCheck)
	{
		var alertUser = self.alertNotifyUsers[logUserId];
		if (!alertUser) return false;
		else if (alertUser && !type) return true;

		return (alertUser.getStateValid(type, true, missingDataCheck))
	};

	/**
	 * Returns all stored AlertNotifyUsers with the specified type not set to 'unused'
	 * @param {string|string[]} type - AlertNotifyUser.type
	 * @param {AlertMissingDataCheck|null} missingDataCheck
	 * @param {Boolean=true} allowNull - Allow null missing data checks to be returned with undefined missingDataCheck query
	 *
	 * @return {AlertNotifyUser[]}
	 */
	this.getNotifyUsersWithType = function(type, missingDataCheck, allowNull)
	{
		allowNull = (typeof allowNull === 'boolean') ? allowNull : true;
		if (Array.isArray(type))
			return type.map(function(alertType)
			{
				return self.getNotifyUsersWithType(alertType)
			}).reduce(function(arr, current)
			{
				return arr.concat(current
					.filter(function(alertNotifyUser)
					{
						var index = arr.findIndex(function(includedUser) { return includedUser.logUser.id === alertNotifyUser.logUser.id });
						return index < 0;
					}));
			}, []);

		if (!AlertNotifyUser.type.isValidType(type))
			return [];
		
		return Object.values(self.alertNotifyUsers).filter(function(alertNotifyUser)
		{
			if (missingDataCheck !== undefined || type !== AlertNotifyUser.type.missingData)
				return alertNotifyUser.getStateValid(type, true, missingDataCheck);
			
			else return allowNull;
		});
	};

	/**
	 * Adds a parameter and converts it to an AlertParameter
	 * @param {AlertParameter} parameter - new parameter
	 */
	this.addParameter = function(parameter)
	{
		if (parameter instanceof AlertParameter)
			parameter.alert = this.id;
		else
			parameter = Alerts.createParameter(this.id, parameter);
		
		this.parameters.push(parameter);
		this.sortParameters();
	};

	/**
	 * Sorts the parameter list stored in the array based on key and required value
	 * @return {AlertParameter[]}
	 */
	this.sortParameters = function()
	{
		function sortByOrder(p1, p2)
		{
			var p1Order = (!isNaN(p1.sortOrder) && p1.sortOrder !== null) ? p1.sortOrder : Number.MAX_VALUE;
			var p2Order = (!isNaN(p2.sortOrder) && p2.sortOrder !== null) ? p2.sortOrder : Number.MAX_VALUE;

			if (p1Order < p2Order)
				return -1;
			else if (p1Order > p2Order)
				return 1;
			else return 0;
		};

		this.parameters.sort(function(/*AlertParameter*/ p1,/*AlertParameter*/ p2)
		{
			var p1SortVal = (p1.key) ? 2 : (p1.required) ? 1 : 0;
			var p2SortVal = (p2.key) ? 2 : (p2.required) ? 1 : 0;

			if (p1SortVal === p2SortVal)
				return sortByOrder(p1, p2);

			return p2SortVal - p1SortVal;
		});

		for (var i = 0; i < this.parameters.length; i++)
		{
			this.parameters[i].sortOrder = i * 10;
		};

		return this.parameters;
	};

	/**
	 * Adds a new Missing Data check object
	 * @param {function} cronChangeListener
	 *
	 * @return {MissingDataCheck}
	 */
	this.addMissingDataCheck = function(cronChangeListener)
	{
		var missingDataCheck = this.missingDataChecks[this.missingDataChecks.push(Alerts.createMissingDataCheck(self)) - 1];
		if (typeof cronChangeListener === 'function')
			missingDataCheck.cronSpecChangeListener = cronChangeListener;
		return missingDataCheck;
	};

	/**
	 * Removes a specified missing data check from the alert
	 * @param {AlertMissingDataCheck} missingDataCheck
	 *
	 * @return {number} - The length of the MissingDataCheck array after deletion
	 */
	this.removeMissingDataCheck = function(missingDataCheck)
	{
		var index = this.missingDataChecks.findIndex(function(check) { return check === missingDataCheck });
		if (index > -1)
			this.missingDataChecks.splice(index, 1);

		return this.missingDataChecks.length;
	};

	/**
	 * Clears all missing data checks and clears the missing data message.
	 */
	this.clearMissingDataChecks = function()
	{
		this.getNotifyUsersWithType(AlertNotifyUser.type.missingData).forEach(function(alertNotifyUser)
		{
			alertNotifyUser[AlertNotifyUser.type.missingData].state = AlertNotifyUser.state.unused;
		});
		this.missingDataChecks.length = 0;
		this.missingDataMessage = '';
		this.missingDataSubject = '';
	};

	/**
	 * Verifies all missing data checks have valid cron
	 * @return {boolean}
	 */
	this.verifyMissingDataChecks = function()
	{
		return this.missingDataChecks.every(function(check) { return check.hasValidCronObject() && check.cronSpecVerified })
	};

	/**
	 * Removes a specified alert parameter from the alert
	 * @param {AlertParameter} alertParameter
	 */
	this.removeParameter = function(alertParameter)
	{
		var index = this.parameters.findIndex(function(param) { return alertParameter === param });
		if (index > -1)
			this.parameters.splice(index, 1);
	};
	
	this.getKeyParameters = function()
	{
		return this.parameters.filter(function(param)
		{
			return param.key;
		})
	};

	/**
	 * Creates and returns a copy of this Alert
	 * @param {Object=} from - Creates a copy of the alert and appends values from object to new
	 * @return {any}
	 */
	this.copy = function(from)
	{
		var newAlert = JSON.parse(JSON.stringify(self));
		
		if (typeof from === 'object')
			Object.assign(newAlert, from);
		
		Alerts.createAlert(self.logId, newAlert);
		return newAlert;
	};
	
	/**
	 * Compares alert save models to determine if there are differences
	 * @param {Alert} alert
	 * @return {Boolean}
	 */
	this.compare = function(alert)
	{
		function compare(o1, o2, count)
		{
			count = !isNaN(parseInt(count)) ? count : -1;
			count += 1;
			
			try {
				return Object.keys(o1).every(function(o1key)
				{
					if (typeof o1[o1key] === 'function' && typeof o1[o1key] === 'function')
						return true;
					else if (typeof o1[o1key] !== 'object' || o1[o1key] === null || o2[o1key] === null)
						return o1[o1key] === o2[o1key];
					else if (typeof o1[o1key] === 'object' && typeof o2[o1key] === 'object' && count < 5)
						return compare(o1[o1key],o2[o1key], count)
					else
						return false;
				})
			} catch(e)
			{
				console.error(e);
				return false;
			}
		}
		if (!(alert instanceof Alert)) return false;
		
		var missingDataCheckFilter = function(dataCheck)
		{
			// Check that the missing data check has a schedule assigned or has been saved previously by ID
			return (dataCheck instanceof AlertMissingDataCheck && (!!dataCheck.scheduler || dataCheck.id > 0))
		}
		
		return (
			
			// Base Alert
			compare(this.getSaveModel(), alert.getSaveModel()) &&
				
				// Parameters
				this.parameters.length === alert.parameters.length &&
				this.parameters.every(function(param, index)
				{
					var cmpModel = alert.parameters[index];
					if (!cmpModel) return false;
					return compare(param.getSaveModel(), cmpModel.getSaveModel())
				}) &&
				
				// Alert Messages
				compare(this.getAlertMessagesSaveModel(), alert.getAlertMessagesSaveModel()) &&
				
				// Notify Users
				this.getAlertNotifyUsersSaveModel().length === alert.getAlertNotifyUsersSaveModel().length &&
				this.getAlertNotifyUsersSaveModel().every(function(notifyUser,index)
				{
					var cmpModel = alert.getAlertNotifyUsersSaveModel()[index];
					if (!cmpModel) return false;
					return compare(notifyUser.saveModel, cmpModel.saveModel);
				}) &&
				
				// Missing Data Checks
				this.getMissingDataChecks().filter(missingDataCheckFilter).length === alert.getMissingDataChecks().filter(missingDataCheckFilter).length &&
				this.getMissingDataChecks().every(function(mdc, index)
				{
					var cmpModel = alert.getMissingDataChecks()[index];
					if (!cmpModel) return false;
					return compare(mdc.getSaveModel(), cmpModel.getSaveModel())
				})
		)
	}

	/**
	 * Returns the direct url to the alert with the baseURL provided
	 * @param {string} baseUrl
	 * @return {string|undefined}
	 */
	this.getDirectUrl = function(baseUrl)
	{
		if (this.id >= 0)
			return baseUrl + '/api/alerts/' + this.id;
	};

	/**
	 * Returns the savable version of this alert for compatibility
	 * @param {string} baseUrl
	 * @return {{log: string, complexObject: (Alert.complexObject._links.self.href|null), name: (*), suppressed: boolean}}
	 */
	this.getSaveModel = function(baseUrl)
	{
		return {
			name: (typeof this.name === 'string') ? this.name.slice(0,250) : this.name,
			log: baseUrl + '/api/log/' + this.logId,
			suppressed: this.suppressed,
			newNotesOnly: !!this.newNotesOnly,
			complexObject: (self.complexObject) ? self.complexObject._links.self.href : null
		}
	};

	/**
	 * Return the savable version of this alert's status messages
	 * @param {string} baseUrl
	 * @return {({alert: string, message: string, status: string})[]}
	 */
	this.getAlertMessagesSaveModel = function(baseUrl)
	{
		var subject = (typeof self.subject === 'string') ? self.subject.slice(0, 250) : self.subject;
		var missingDataSubject = (typeof self.missingDataSubject === 'string') ? self.missingDataSubject.slice(0, 250) : self.missingDataSubject;
		
		var toReturn = [
			{
				alert: self.getDirectUrl(baseUrl),
				status: baseUrl + '/api/alertStatuses/1',
				message: self.activeMessage,
				subject: subject
			},
			{
				alert: self.getDirectUrl(baseUrl),
				status: baseUrl + '/api/alertStatuses/2',
				message: self.clearMessage,
				subject: subject
			},
			{
				alert: self.getDirectUrl(baseUrl),
				status: baseUrl + '/api/alertStatuses/3',
				message: self.missingDataMessage,
				subject: missingDataSubject
			}]
			.filter(function(msgObj, index)
			{
				//Returns only alert messages with text
				return (msgObj.message.trim().length > 0 || msgObj.subject.trim().length > 0)
			});

		return toReturn;
	};
	
	/**
	 * Returns all message types that are no longer valid to be saved
	 * @param {String} baseUrl
	 * @returns {String[]}
	 */
	this.getAlertMessagesDeletionModel = function(baseUrl)
	{
		var toReturn = [];
		if (this.activeId > 0 && this.activeMessage.trim().length <= 0)
		{
			toReturn.push(baseUrl + '/api/alertStatusMessages/' + this.activeId)
		}
		if (this.clearId > 0 && this.clearMessage.trim().length <= 0)
		{
			toReturn.push(baseUrl + '/api/alertStatusMessages/' + this.clearId)
		}
		if (this.missingId > 0 && this.missingDataMessage.trim().length <= 0)
		{
			toReturn.push(baseUrl + '/api/alertStatusMessages/' + this.missingId)
		}
		return toReturn;
	};

	/**
	 * Gets the model for the stored AlertNotifyUsers
	 * @param baseUrl
	    * @return {{stateModel: {id: number, state: string } saveModel: {alert: string, user: string, notifyOnStatus: string, notifyEachUpdate: boolean}}[]}
	 */
	this.getAlertNotifyUsersSaveModel = function(baseUrl)
	{
		return Object.values(self.alertNotifyUsers).map(function(notifyUser)
		{
			return notifyUser.getSaveModel(self, baseUrl);
		}).reduce(function(arr, newArr)
		{
			return arr.concat(newArr);
		}, []);
	};

	this.getParameterNames = function(joinStr)
	{
		var mapped = this.parameters.map(function(param) { return param.name });
		return (typeof joinStr === 'string')
			? mapped.join(joinStr)
			: mapped;
	};
	
	/**
	 * Gets a parameter by ID from the parameter list
	 * @param {number|string} parameterId
	 * @return {Parameter|undefined}
	 */
	this.getParameterById = function(parameterId)
	{
		if (isNaN(parameterId) || parameterId === null) return;
		parameterId = parseInt(parameterId);
		
		return this.parameters.find(function(param)
		{
			return param.id === parameterId;
		})
	};
	
	/**
	 * @return {AlertMissingDataCheck[]}
	 */
	this.getMissingDataChecks = function()
	{
		return this.missingDataChecks;
	};
	
	/**
	 * @param {AlertMissingDataCheck} missingDataCheck
	 * @return {AlertNotifyUser[]}
	 */
	this.getMissingDataCheckUsers = function(missingDataCheck)
	{
		return self.getNotifyUsersWithType(AlertNotifyUser.type.missingData)
			.filter(function(dataCheckUser)
			{
				return dataCheckUser.hasMissingDataCheck(missingDataCheck);
			})
	};
	
	// Setup original missing data checks
	this.missingDataChecks = (Array.isArray(this.missingDataChecks)) ? this.missingDataChecks : [];
	this.missingDataChecks.forEach(function(x) { Alerts.createMissingDataCheck(self, x) });
	
	// Setup original users
	this.notifyUsers = (Array.isArray(this.notifyUsers)) ? this.notifyUsers : [];
	this.notifyUsers.forEach(function(oldUser)
	{
		var type = AlertNotifyUser.type.fromId(oldUser.notifyOnStatus.id);
		var state = (oldUser.notifyEachUpdate) ? AlertNotifyUser.state.always : AlertNotifyUser.state.transition;
		
		var missingDataCheck = (type !== AlertNotifyUser.type.missingData)
			? undefined
			: (oldUser.missingDataCheckId === null)
				? null
				: self.missingDataChecks.find(function(dataCheck)
				{
					return dataCheck.id === parseInt(oldUser.missingDataCheckId)
				});
		
		var alertUser = self.setNotifyUserState(oldUser.user, type, state);
		if (type === AlertNotifyUser.type.missingData)
			alertUser.addMissingDataCheck(missingDataCheck, oldUser.id, state);
		else
			alertUser[type].id = oldUser.id;

	});

	this.sortParameters();
}

function AlertParameter(alertId)
{
	this.alert = alertId || -1;
	this.sortOrder = (!isNaN(this.sortOrder) && this.sortOrder !== null) ? parseInt(this.sortOrder) : null;
	this.name = this.name || '';
	this.required = (typeof this.required === 'boolean') ? this.required : false;
	this.key = (typeof this.key === 'boolean') ? this.key : false;

	if (!(this.hasOwnProperty('id') && this.id !== null && !isNaN(this.id)))
		this.id = -1;

	this.keyValueField = ((this.key) ? 2 : (this.required) ? 1 : 0).toString();
	
	this.constraintValueField = '0';
	
	var tagConstraint = undefined;
	var listConstraint = undefined;
	
	this.clearConstraintValueField = function()
	{
		this.constraintValueField = '0';
		tagConstraint = undefined;
		listConstraint = undefined;
	};
	
	this.setTagConstraint = function(tag, parentDepth)
	{
		parentDepth = !isNaN(parseInt(parentDepth)) ? parseInt(parentDepth) : null;
		
		if (!tag)
			tag = { id: null };
		
		if (isNaN(parseInt(tag.id)))
		{
			tagConstraint = {
				tag: null,
				depth: parentDepth
			};
			listConstraint = undefined;
			return;
		}
		
		tagConstraint = {
			tag: tag,
			depth: parentDepth
		};
		
		listConstraint = undefined;
		
		this.constraintValueField = '1';
	};
	
	this.setListConstraint = function(list)
	{
		if (!list || isNaN(parseInt(list.id)))
		{
			listConstraint = undefined;
			tagConstraint = undefined;
			return;
		}
		
		listConstraint = list;
		tagConstraint = undefined;
		
		this.constraintValueField = '2';
	};
	
	if (this.tagParentConstraint)
		this.setTagConstraint(this.tagParentConstraint, this.tagDepth);
	
	else if (this.choiceListConstraint)
		this.setListConstraint(this.choiceListConstraint);
	
	this.fromKeyValue = function(value)
	{
		this.key = value >= 2;
		this.required = value >= 1;
	};
	
	this.getConstraintText = function()
	{
		if (listConstraint)
			return 'Constrained to List ' + listConstraint.name;
		
		if (tagConstraint && tagConstraint.tag && typeof tagConstraint.tag.viewString === 'string')
		{
			var toReturn = 'Constrained to children of tag ' + tagConstraint.tag.viewString;
			
			if (!isNaN(parseInt(tagConstraint.depth)))
				toReturn += ' to a depth of ' + tagConstraint.depth;
			
			return toReturn;
		}
		return '';
	};

	this.getDirectUrl = function()
	{
		if (this.id && this.id >= 0)
			return '/api/alertParameters/' + this.id
	};
	
	this.getTagConstraint = function()
	{
		return tagConstraint ? Object.assign({}, tagConstraint) : undefined;
	};
	
	this.getListConstraint = function()
	{
		return listConstraint;
	};
	
	this.hasValidTagConstraint = function()
	{
		return !!this.getTagConstraint() && !!this.getTagConstraint().tag
	}
	
	this.hasValidListConstraint = function()
	{
		return !!this.getListConstraint();
	}

	/**
	 *
	 * @param {AlertReportTrigger} alertReportTrigger
	 * @param from
	 * @return {AlertParameterMapping}
	 */
	this.createParameterMapping = function(alertReportTrigger, from)
	{
		return alertReportTrigger.createParameterMapping(this, from);
	};

	/**
	 * Creates a savable version of this entity
	 * @param {string} baseUrl
	 * @return {{tagParentConstraint: null, alert: string, sortOrder: number | null, name: (*), tagDepth: null, choiceListConstraint: null, key: boolean, required: boolean}}
	 */
	this.getSaveModel = function(baseUrl)
	{
		var toReturn = {
			alert: baseUrl + '/api/alerts/' + this.alert,
			name: (typeof this.name === 'string') ? this.name.slice(0, 250) : this.name,
			sortOrder: this.sortOrder,
			key: this.keyValueField == 2,
			required: this.keyValueField >= 1,
			tagParentConstraint: null,
			choiceListConstraint: null,
			tagDepth: null
		};
		
		if (toReturn.key)
			if (this.constraintValueField === '1' && this.hasValidTagConstraint())
			{
				toReturn.tagParentConstraint = (tagConstraint.tag && !isNaN(parseInt(tagConstraint.tag.id)))
					? baseUrl + '/api/tagValues/' + tagConstraint.tag.id
					: null;
				
				toReturn.tagDepth = tagConstraint.depth
			}
			else if (this.constraintValueField === '2' && this.hasValidListConstraint())
			{
				if (!isNaN(parseInt(listConstraint.id)))
					toReturn.choiceListConstraint = baseUrl + '/api/choiceLists/' + listConstraint.id;
			}
			else
			{
				// Disallow unconstrained key
				toReturn.key = false;
			}

		return toReturn;
	};
}

function AlertNotifyUser(logUser)
{
	this.logUser = logUser;

	this.active = new StateInfo(null, -1);

	this.clear = new StateInfo(null, -1);

	/**
	 * @type {StateInfo[]}
	 */
	this.missingData = [];

	function StateInfo(missingDataCheck, id, state)
	{
		this.id = (!isNaN(parseInt(id))) ? id : -1;
		this.state = (typeof state === 'string') ? state : AlertNotifyUser.state.unused;
		this.missingDataCheck = missingDataCheck;
	}

	this.getName = function()
	{
		return this.logUser.user.firstName + ' ' + this.logUser.user.lastName;
	};
	
	/**
	 * Adds a missing data check or updates the one stored with the new state
	 * @param {AlertMissingDataCheck|null} missingDataCheck
	 * @param {number} id
	 * @param {AlertNotifyUser.state} state
	 * @return {AlertNotifyUser}
	 */
	this.addMissingDataCheck = function(missingDataCheck, id, state)
	{
		state = (AlertNotifyUser.state.isValidState(state)) ? state : AlertNotifyUser.state.always;
		
		if (missingDataCheck instanceof AlertMissingDataCheck || missingDataCheck === null)
		{
			var index = this.missingData.findIndex(function(stateInfo)
			{
				return stateInfo.missingDataCheck === missingDataCheck;
			});
			
			if (index < 0)
				this.missingData.push(new StateInfo(missingDataCheck, id, state));
			else
				this.missingData[index].state = state;
		}
		return this;
	};
	
	/**
	 * Removes a missing data check by marking the state as unused
	 * @param {AlertMissingDataCheck|{id:number}|null} missingDataCheck
	 *
	 * @return {AlertNotifyUser}
	 */
	this.removeMissingDataCheck = function(missingDataCheck)
	{
		var id;
		var index;
		if (missingDataCheck instanceof AlertMissingDataCheck || missingDataCheck === null)
		{
			index = this.missingData.findIndex(function(missingDataUserInfo)
			{
				return missingDataUserInfo.missingDataCheck === missingDataCheck
			});
		}
		else if (!isNaN(id = parseInt(missingDataCheck)) || (missingDataCheck && !isNaN(id = parseInt(missingDataCheck.id))))
		{
			index = this.missingData.findIndex(function(missingDataUserInfo)
			{
				return missingDataUserInfo.missingDataCheck.id === id;
			});
		}
		
		if (index >= 0)
			this.missingData[index].state = AlertNotifyUser.state.unused;
		
		return this;
	};
	
	/**
	 * Searches for the specified missing data check and determines whether it is valid
	 * @param {AlertMissingDataCheck|null} missingDataCheck
	 * @param {boolean=false} allowNever - Whether states found as 'never' can be returned as true
	 *
	 * @return {boolean}
	 */
	this.hasMissingDataCheck = function(missingDataCheck, allowNever)
	{
		allowNever = (typeof allowNever === 'boolean') ? allowNever : false;
		
		return 0 <= this.missingData.findIndex(function(stateInfo)
		{
			if (!AlertNotifyUser.state.isValidSaveState(stateInfo.state))
				return false;
			if (stateInfo.state === AlertNotifyUser.state.unused || (!allowNever && stateInfo.state === AlertNotifyUser.state.never))
				return false;
			return stateInfo.missingDataCheck === missingDataCheck
		});
	};

	/**
	 * Gets statuses that have valid ID but invalid save states for deletion
	 * @return {number[]}
	 */
	this.getInvalidIds = function()
	{
		var toReturn = [];
		if (this.active.id > -1 && !this.getStateValid(AlertNotifyUser.type.active))
			toReturn.push(this.active.id);

		if (this.clear.id > -1 && !this.getStateValid(AlertNotifyUser.type.clear))
			toReturn.push(this.clear.id);

		this.missingData.forEach(function(stateInfo)
		{
			if (stateInfo.id < 1)
				return;

			// Checks if the missing data check associated has an ID that allows this user to be saved
			if (!AlertNotifyUser.state.isValidSaveState(stateInfo.state) || (stateInfo.missingDataCheck && stateInfo.missingDataCheck.id < 1))
			{
				toReturn.push(stateInfo.id)
			}
		});

		return toReturn;
	};

	/**
	 * Checks if a state is valid within the AlertNotifyUser
	 * @param {string} alertType - AlertNotifyUser.type
	 * @param {boolean=} allowNever - Determines whether 'never' should be checked as a valid state
	 * @param {AlertMissingDataCheck=} missingDataCheck - Missing Data Check to verify for
	 *
	 * @return {boolean}
	 */
	this.getStateValid = function(alertType, allowNever, missingDataCheck)
	{
		allowNever = (typeof allowNever === 'boolean') ? allowNever : false;
		var state;
		
		if (!AlertNotifyUser.type.isValidType(alertType))
			return false;
		else if (alertType === AlertNotifyUser.type.missingData)
		{
			if (missingDataCheck === undefined)
				return false;
			
			var stateInfo = this.missingData.find(function(stateInfo) { return missingDataCheck === stateInfo.missingDataCheck });
			if (!stateInfo)
				return false;
			state = stateInfo.state;
		}
		else
			state = this[alertType].state;
		
		if (!AlertNotifyUser.state.isValidState(state))
			return false;
		else if (state === AlertNotifyUser.state.unused || (state === AlertNotifyUser.state.never && !allowNever))
			return false;
		return true;
	};
	
	/**
	 * Checks whether if either active or clear are in valid states
	 * @return {Boolean}
	 */
	this.getValidNotifyStates = function()
	{
		return AlertNotifyUser.state.isValidSaveState(this.active.state)
			|| AlertNotifyUser.state.isValidSaveState(this.clear.state);
	}

	/**
	 * Gets savable version of this entity
	 * @param {Alert} alert
	 * @param {string} baseUrl
	 *
	 * @return {{stateModel: {id: number, state: string } saveModel: {alert: string, user: string, notifyOnStatus: string, notifyEachUpdate: boolean}}[]}
	 */
	this.getSaveModel = function(alert, baseUrl)
	{
		var toReturn = [];
		var base = {
			alert: alert.getDirectUrl(baseUrl),
			user: baseUrl + '/api/logUsers/' + logUser.id
		};

		if (this.getStateValid(AlertNotifyUser.type.active))
			toReturn.push({
				stateModel: this.active,
				saveModel: Object.assign({
					notifyOnStatus: baseUrl + '/api/alertStatues/1',
					notifyEachUpdate: this.active.state === AlertNotifyUser.state.always
				}, base)
			});

		if (this.getStateValid(AlertNotifyUser.type.clear))
			toReturn.push({
				stateModel: this.clear,
				saveModel: Object.assign({
					notifyOnStatus: baseUrl + '/api/alertStatues/2',
					notifyEachUpdate: this.clear.state === AlertNotifyUser.state.always
				}, base)
			});

		this.missingData.forEach(function(stateInfo)
		{
			if (!AlertNotifyUser.state.isValidSaveState(stateInfo.state) || (stateInfo.missingDataCheck && stateInfo.missingDataCheck.id < 1))
				return;
			
			var missingDataCheckBase = {
				saveModel: Object.assign({
					notifyOnStatus: baseUrl + '/api/alertStatues/3',
					notifyEachUpdate: stateInfo.state === AlertNotifyUser.state.always,
					missingDataCheck: (stateInfo.missingDataCheck)
						? baseUrl + '/api/alertMissingDataChecks/' + stateInfo.missingDataCheck.id
						: null
				}, base)
			};
			
			var toPush = Object.assign({
				stateModel: stateInfo
			}, missingDataCheckBase);
			
			toReturn.push(toPush);
		});

		return toReturn;
	}
}

function AlertMissingDataCheck(alert)
{
	var self = this;
	var allowShiftUpdate = true;

	this.alert = alert;
	this.shift = (this.shift != undefined && typeof this.shift.id === 'number') ? this.shift : { id: undefined };
	
	var original = (typeof this.updatedWithinMinutes === 'number') ? this.updatedWithinMinutes : 0;
	this.hours = Math.floor(original / 60);
	this.minutes = original - (this.hours * 60);

	this.cronSpecChangeListener = undefined;

	this.scheduler = undefined;
	this.cronSpec = undefined;

	this.cronSpecVerified = false;
	this.cronErrorMsg = '';
	
	this.alertInstanceSpecifications = this.alertInstanceSpecifications || {};

	if (this.id === undefined) this.id = -1;
	
	var decoratedTitle = '';
	this.bindScheduler = function(scheduleContainer)
	{

		if (typeof self.cronspec === 'string')
		{
			allowShiftUpdate = false;
			var split = self.cronspec.split(' ');
			var cron = {
				minutes: split[0],
				hours: split[1],
				monthdays: split[2],
				weekdays: split[4]
			};
			scheduleContainer.addScheduler(self.shift.id === undefined ? 'scheduler' : 'shift')
				.then(function(schedulerObj)
				{
					return schedulerObj.scope.fromCronInput(cron);
				})
				.then(function(schedulerScope)
				{
					schedulerScope.onChange();
					schedulerScope.collapseBody(true);
					if (self.shift.id !== undefined)
						schedulerScope.setShiftFromId(self.shift.id);

					allowShiftUpdate = true;
				});
		}
		
		scheduleContainer.addOnSchedulerAdded(function(scope)
		{
			scope.nameEnabled = false;
			(self.scheduler = scope.model[0].scope).addOnChangeEvent(function(scheduler)
			{
				var result = scheduler.getConverterResult();
				self.cronSpec = result.cron;
				decoratedTitle = result.decorated;
				scheduler.changeName('Check for missing notes based on this schedule');
				if (scheduler.selectedShift && allowShiftUpdate)
					self.shift.id = scheduler.selectedShift.id;

				if (typeof self.cronSpecChangeListener === 'function')
					self.cronSpecChangeListener(self);
			})
		});

		scheduleContainer.addOnSchedulerDeleted(function(scope)
		{
			self.shift = { id:undefined };
			self.cronSpec = undefined;
			self.setError();
		});
	};
	
	this.getName = function()
	{
		return this.scheduler && !this.scheduler.isEmpty() ? decoratedTitle : '';
	}

	this.clearError = function()
	{
		self.cronSpecVerified = true;
		self.cronErrorMsg = '';
		if (self.scheduler && typeof self.scheduler.errorMsg === 'string')
			self.scheduler.errorMsg = self.cronErrorMsg;
	};

	this.setError = function(errorMsg)
	{
		self.cronSpecVerified = false;
		if (typeof errorMsg == 'string')
			self.cronErrorMsg = AlertMissingDataCheck.cronError.fromError(errorMsg);
		else
			self.cronErrorMsg = '';

		if (self.scheduler && typeof self.scheduler.errorMsg === 'string')
			self.scheduler.errorMsg = self.cronErrorMsg;
	};
	
	/**
	 * Sets a callback function for when the cronSpec has changed
	 * @param {Function} newFunc
	 * @return {AlertMissingDataCheck}
	 */
	this.setCronSpecChangeListener = function(newFunc)
	{
		if (typeof newFunc === 'function')
			self.cronSpecChangeListener = newFunc;
		return self;
	};
	
	/**
	 * Executes the change listener with the stored scheduler
	 */
	this.executeChangeListener = function()
	{
		if (typeof self.cronSpecChangeListener === 'function' && self)
			self.cronSpecChangeListener(self)
	};

	this.hasValidCronObject = function()
	{
		try
		{
			return !(Object.keys(self.cronSpec).length !== 5 || !Object.values(self.cronSpec).every(function (value)
			{
				return typeof value === 'string'
			}));

		}
		catch(e)
		{
			return false;
		}
	};
	
	this.customizers = []
	this.addOnSaveCustomizer = function(customizer)
	{
		if (typeof customizer === 'function')
			this.customizers.push(customizer);
	};

	this.getDirectUrl = function(baseUrl)
	{
		return baseUrl + '/api/alertMissingDataChecks/' + this.id;
	};
	
	/**
	 *
	 * @param baseUrl
	 * @return {{cronspec: string, alert: string, shift?: (string), updatedWithinMinutes: (Alerts.updatedWithinMinutes|number|*)}}
	 */
	this.getSaveModel = function(baseUrl)
	{
		var base = {
			alert: baseUrl + '/api/alerts/' + self.alert,
			cronspec: self.cronSpec ? Object.values(self.cronSpec).join(' ') : self.cronspec,
			updatedWithinMinutes: self.hours * 60 + self.minutes
		};
		if (typeof self.shift.id === 'number')
			base.shift = '/api/scheduledShifts/' + self.shift.id;

		this.customizers.forEach(function(callback){ callback(base); })
		return base;
	}
}

function AlertReportTrigger(report, alertObjId)
{
	var self = this;

	this.id = (typeof this.id === 'number') ? this.id : -1;
	this.report = report;
	this.alert = alertObjId;

	/**
	 * @type {Alert|undefined}
	 */
	this.alertObject = undefined;

	this.onMatch = AlertNotifyUser.type.none;
	this.onNoMatch = AlertNotifyUser.type.none;

	/**
	 * @type {AlertParameterMapping[]}
	 */
	this.parameterMappings = Array.isArray(this.parameterMappings) ? this.parameterMappings : [];
	this.parameterMappings.forEach(function(param)
	{
		AlertParameterMapping.call(param, self, Alerts.createParameter(self.alert, param.parameter))
	});

	this.setId = function(newId)
	{
		this.id = newId;
	};

	this.createParameterMapping = function(parameter, from)
	{
		var mapping = Alerts.createAlertParameterMapping(this, parameter, from);
		this.parameterMappings.push(mapping);
		this.pruneBrokenMappings();
		return mapping;
	};
	
	this.pruneBrokenMappings = function()
	{
		if (!this.alertObject) return;
		var alert = this.alertObject;
		this.parameterMappings = this.parameterMappings.filter(function(mapping)
		{
			return -1 !== alert.parameters.findIndex(function(param){ return mapping.parameter.id === param.id });
		})
	};
	
	this.pruneBrokenMappings();

	this.getDirectUrl = function(baseUrl)
	{
		return baseUrl + '/api/reportAlertTriggers/' + this.id;
	};

	this.getSaveModel = function(baseUrl)
	{
		return {
			report: baseUrl + '/api/reports/' + this.report.id,
			alertObject: baseUrl + '/api/alertObjects/' + this.alert,
			onMatchStatus: AlertNotifyUser.type.getDirectUrl(baseUrl, this.onMatch),
			onNoMatchStatus: AlertNotifyUser.type.getDirectUrl(baseUrl, this.onNoMatch)
		}
	};


	if (this.onMatchStatus && this.onMatchStatus.id)
		this.onMatch = AlertNotifyUser.type.fromId(this.onMatchStatus.id);

	if (this.onNoMatchStatus && this.onNoMatchStatus.id)
		this.onNoMatch = AlertNotifyUser.type.fromId(this.onNoMatchStatus.id);
};

function AlertParameterMapping(trigger, parameter)
{
	this.id = (typeof this.id === 'number') ? this.id : -1;
	this.trigger = trigger;
	this.parameter = parameter;

	this.stringValue = (typeof this.stringValue === 'string') ? this.stringValue : '';
	this.templateSegment = undefined;

	this.getDirectUrl = function(baseUrl)
	{
		return baseUrl + '/api/reportAlertTriggerParameterMappings/' + this.id;
	};

	this.verifyMapping = function()
	{
		if (!this.parameter.key && !this.parameter.required)
			return true;

		if (!this.parameter.isLiteralText)
			return this.templateSegment !== undefined;
		else
			return !!this.stringValue.length;
	};

	this.getSaveModel = function(baseUrl)
	{
		var toReturn =  {
			trigger: baseUrl + '/api/reportAlertTriggers/' + this.trigger.id,
			parameterName: this.parameter.name,
			templateValue: (!this.parameter.isLiteralText && this.templateSegment !== undefined) ? baseUrl + '/api/templateSegments/' + this.templateSegment : null,
			stringValue: (this.parameter.isLiteralText) ?  this.stringValue : null
		};

		return toReturn;
	}
}

AlertNotifyUser.state = {
	unused: 'unused',
	never: 'never',
	transition: 'transition',
	always: 'always',
	
	isValidState: function(toCheck)
	{
		return -1 < ['unused', 'never', 'transition', 'always'].indexOf(toCheck)
	},
	
	isValidSaveState: function(toCheck)
	{
		return toCheck === AlertNotifyUser.state.transition || toCheck === AlertNotifyUser.state.always;
	}
};

AlertNotifyUser.type = {
	active: 'active',
	clear: 'clear',
	missingData: 'missingData',
	notMissingData: 'notMissingData',

	none: 'none',
	
	isValidType: function(toCheck)
	{
		return -1 < ['active', 'clear', 'missingData', 'notMissingData'].indexOf(toCheck)
	},

	fromId: function(id)
	{
		switch (id)
		{
			case 1:
				return 'active';
			case 2:
				return 'clear';
			case 3:
				return 'missingData';
			case 4:
				return 'notMissingData';
		}
	},

	getDirectUrl: function(baseUrl, type)
	{
		var base = (baseUrl || '') + '/api/alertStatues/';
		switch (type)
		{
			case 'active':
				base += '1';
				return base;
			case 'clear':
				base += '2';
				return base;
			case 'missingData':
				base += '3';
				return base;
			case 'notMissingData':
				base += '4';
				return base;

			default:
				return undefined;
		}
	}
};

AlertMissingDataCheck.cronError = {
	frequency: 'A schedule cannot be configured for more than 4 times an hour.',
	unknown: 'This schedule is too infrequent to be saved.',

	fromError: function(errorMsg)
	{
		if (typeof errorMsg !== 'string') return AlertMissingDataCheck.cronError.unknown;
		errorMsg = errorMsg.toLowerCase();

		if (errorMsg.includes('cronspec is too frequent')) return AlertMissingDataCheck.cronError.frequency;

		return AlertMissingDataCheck.cronError.unknown;
	}
};

Object.freeze(AlertNotifyUser);
Object.freeze(AlertNotifyUser);
Object.freeze(AlertMissingDataCheck);

var Alerts =
{
	/**
	 * Alert Entity Representation
	 * @param {number} logId - Log ID that the alert belongs to
	 * @constructor
	 */
	Alert: Alert,

	/**
	 * Alert Parameter representation
	 * @param {number} alertId - Alert ID that this parameter belongs to
	 * @constructor
	 */
	Parameter: AlertParameter,

	/**
	 * AlertNotifyUser Representation
	 * @param {Object} logUser - The LogUser of this entity
	 * @constructor
	 */
	NotifyUser: AlertNotifyUser,

	/**
	 * Alert Missing Data check representation
	 * @param {Alerts.Alert} alert
	 * @constructor
	 */
	MissingDataCheck: AlertMissingDataCheck
};

/**
 *
 * @param logId
 * @param {object=} from - Object to call the setup from
 * @return {Alert}
 */
Alerts.createAlert = function(logId, from)
{
	if (from)
	{
		Alerts.Alert.call(from, logId);
		from.__proto__ = Alert.prototype;
		return from;
	}
	return new Alerts.Alert(logId)
};

/**
 *
 * @param alertId
 * @param {object=} from - Object to call the setup from
 * @return {AlertParameter}
 */
Alerts.createParameter = function(alertId, from)
{
	if (from)
	{
		Alerts.Parameter.call(from, alertId);
		from.__proto__ = AlertParameter.prototype;
		return from;
	}
	return new Alerts.Parameter(alertId)
};

/**
 *
 * @param logUser
 * @param {object=} from - Object to call the setup from
 * @return {AlertNotifyUser}
 */
Alerts.createNotifyUser = function(logUser, from)
{
	if (from)
	{
		Alerts.NotifyUser.call(from, logUser);
		from.__proto__ = AlertNotifyUser.prototype;
		return from;
	}
	return new Alerts.NotifyUser(logUser)
};

/**
 *
 * @param {Alert} alert
 * @param {object=} from - Object to call the setup from
 * @return {AlertMissingDataCheck}
 */
Alerts.createMissingDataCheck = function(alert, from)
{
	if (from)
	{
		Alerts.MissingDataCheck.call(from, alert.id);
		from.__proto__ = AlertMissingDataCheck.prototype;
		return from;
	}
	return new Alerts.MissingDataCheck(alert.id)
};

/**
 * Creates a new AlertReportTrigger or call the function on a supplied object
 * @param {report} report - Report
 * @param {Alert} alert - Alert
 * @param {Object=} from
 * @return {AlertReportTrigger}
 */
Alerts.createReportTrigger = function(report, alert, from)
{
	if (from)
	{
		AlertReportTrigger.call(from, report, alert.complexObject.id);
		from.__proto__ = AlertReportTrigger.prototype;
		return from;
	}
	return new AlertReportTrigger(report, alert.complexObject.id);
};

/**
 * Creates a new AlertParameterMapping or calls the function a on a supplied object
 * @param {AlertReportTrigger} trigger
 * @param {AlertParameter} parameter
 * @param from
 * @return {AlertParameterMapping}
 */
Alerts.createAlertParameterMapping = function(trigger, parameter, from)
{
	if (from)
	{
		AlertParameterMapping.call(from, trigger, parameter);
		from.__proto__ = AlertParameterMapping.prototype;
		return from;
	}
	return new AlertParameterMapping(trigger, parameter);
};

export { Alert, Alerts, AlertMissingDataCheck, AlertNotifyUser };